<template>
    <div class="btn-group version-selector pull-right">
        <button type="button" 
            class="dropdown-link dropdown-toggle language-toggle" 
            data-toggle="dropdown" 
            aria-haspopup="true" 
            aria-expanded="false"
        >
            {{activeLangTitle.name}}
        </button>
        <div class="dropdown-menu dropdown-menu-right">
            <button type="button"
                class="dropdown-item"
                v-for="language in languages.listing" 
                :key="language.id"  
                v-on:click="setLang(language.id)"
            >
                {{language.name}}
            </button>
        </div>
    </div>
</template>
<script type="text/javascript">
export default {
    name: "product-lang-toggle",
    data() {
        return {
            uiStates: {
                errorMessage: null,
                showLoading: false
            },
            activeLangTitle: "Master",
            languages: {
                active: 0
            }
        };
    },
    mounted() {
        this.languages = this.$parent.$parent.languages;
        this.activeLangTitle = this.$parent.$parent.languages.listing.find(
            x => x.id === this.$parent.$parent.languages.active
        );
        this.$emit("language-selection", this.activeLangTitle);
    },
    methods: {
        setLang(lang) {
            this.$emit("language-change", lang);
            this.$parent.$parent.languages.active = lang;
            this.activeLangTitle = this.languages.listing.find(
                language => language.id === lang
            );
            this.$emit("language-selection", this.activeLangTitle);
        }
    }
};
</script>
<style scoped lang="scss">
.language-toggle {
    border: 1px solid #dedede !important;
    background: white !important;
    padding: 0.5rem 1rem !important;
    border-radius: 5px !important;
    color: #576670 !important;
}

.language-toggle::after {
    margin-left: 1rem !important;
}
</style>
